import { Component, OnInit } from '@angular/core';
import { MergeTemplateService } from '../../../service/sms/merge-template';
import { MergeTemplate } from '../../../model/merge-template';

@Component({
  selector: 'app-merge-template',
  templateUrl: './merge-template.component.html',
  styleUrls: ['./merge-template.component.scss']
})
export class MergeTemplateComponent implements OnInit {

  constructor(private tempService: MergeTemplateService) { }

  protected maxItemsPerPage: number = 10;
  protected page: number = 1;
  protected total: number;

  protected keyword: string = '';

  public template_list:MergeTemplate[] = [];

  public merge_options : any = ['PartnerID','Salutation','Street1','Street2','Street3','City','Gender','Birthdate'];

  public loader: boolean = false

  public each_temp:MergeTemplate = {
     id:'',
     template:'',
     created_at:'',
     updated_at:''
  };
  
  ngOnInit() {
    this.loadTable()
  }

  loadTable(){
    this.loader = true
    this.tempService.getTemplate(this.maxItemsPerPage,this.page,this.keyword).subscribe(
      (data:any) => {
        this.template_list = data.data
        this.total = data.total;
        this.loader = false
        console.log('Temp:' + this.template_list.length)
      },
      (err:any) => {
         alert('Error:' + JSON.stringify(err))
         this.loader = false
      }
   )
  }


  loadTemplate(row){
    this.each_temp = row
   // alert('Edit Template:' + JSON.stringify(row))
  }


  saveTemplate(){
    this.loader = true
     this.tempService.saveTemplate(this.each_temp).subscribe(
       (data) => {
          //alert(JSON.stringify(data))
          alert('Successfully  Saved Template')
          this.loadTable()
          this.newTemplate()
       }
     )
  }

  newTemplate(){
    this.each_temp = {
      id:'',
      template:'',
      created_at:'',
      updated_at:''
   };
  }

  getTemplateDetails(maxItemsPerPage){
      this.maxItemsPerPage = maxItemsPerPage
      this.loadTable();
  }


  mergeAdd(mergeAdd){
    this.each_temp.template = this.each_temp.template + '{{' + mergeAdd + '}}'
  }

}
